export default __webpack_public_path__ + "static/media/signout-icon.23a981ed.svg";